import React, { Suspense, lazy } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import LoginForm from "./Pages/LoginForm";
import RegisterForm from "./Pages/RegisterForm";
import ForgotPassword from "./Pages/ForgetPasswordForm";
import CheckEmail from "./Pages/CheckEmail";
import VerifyEmail from "./Pages/VerifyEmail";
import RegisterDetails from "./Pages/RegisterAccountDetails";
import CreateNewPassword from "./Pages/CreateNewPassword";
import PasswordSuccess from "./Pages/PasswordSuccess";
import ResetVerifyCode from "./Pages/ResetVerifyCode";
import ChangePassword from "./Pages/ChangePassword";
const Overview = lazy(() => import("./Pages/dashboard/Overview"));
const Accuracy = lazy(() => import("./Pages/dashboard/Accuracy"));
const Insights = lazy(() => import("./Pages/dashboard/Insights"));
const Infrastructure = lazy(() => import("./Pages/dashboard/Infrastructure"));
const Settings = lazy(() => import("./Pages/dashboard/Settings"));
const TenantOAuthConfig = lazy(() => import("./Pages/dashboard/TenantOAuthConfig"));
const Profile = lazy(() => import("./Pages/Profile"));
const IngestionPage = lazy(() => import("./Pages/IngestionPage/IngestionPage"));
const ChatBotPage = lazy(() => import("./Pages/BotPage/ChatBotPage"));
const MfaSetup = lazy(() => import("./Pages/Security/MfaSetup"));
// import Insights from "./pages/Insights";
// import Accuracy from "./pages/Accuracy";
// import Infrastructure from "./pages/Infrastructure";

export default function RoutesComponent() {
  return (
    <Router>
      <Suspense fallback={<div className="p-6 text-sm text-gray-500">Loading…</div>}>
        <Routes>
          {/* <Route path="/" element={<Navigate to="/overview" replace />} /> */}
          <Route path="/login" element={<LoginForm />} />
          <Route path="/signup" element={<RegisterForm />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/check-email" element={<CheckEmail />} />
          <Route path="/reset-verify" element={<ResetVerifyCode />} />
          <Route path="/change-password" element={<ChangePassword />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/register-details" element={<RegisterDetails />} />
          <Route path="/create-new-password" element={<CreateNewPassword />} />
          <Route path="/password-success" element={<PasswordSuccess />} />
          <Route path="/overview" element={<Overview />} />
          <Route path="/accuracy" element={<Accuracy />} />
          <Route path="/insights" element={<Insights />} />
          <Route path="/infrastructure" element={<Infrastructure />} />
          <Route path="/settings" element={<Settings />} />
          {/* <Route path="/settings/oauth" element={<TenantOAuthConfig />} /> */}
          {/* Dedicated MFA setup page */}
          <Route path="/settings/security/mfa-setup" element={<MfaSetup />} />
          <Route path="/chat/*" element={<ChatBotPage />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/ingestion" element={<IngestionPage />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </Suspense>
    </Router>
  );
}
